import { useMemo } from "react";

import { TableRestore } from "@impero-com/ui/domain";
import { useParams } from "react-router-dom";

import { useControlProgramsSuspenseQuery } from "org/control/queries/useControlProgramsQuery";
import { mapAsResourceWithoutAction } from "utils/dtoMapping";

import { buildEntityProgramsListRestoreConfig } from "../../urlUtils";
import {
    EntityViewSideMenu,
    NAVIGATION_ID_CONTROL_PROGRAMS,
} from "../EntityViewSideMenu";

import { EntityProgramsList } from "./EntityProgramsList";

export function EntityProgramsListPage() {
    const { id } = useParams();
    const entityId = Number(id);

    return (
        <EntityViewSideMenu navigationId={NAVIGATION_ID_CONTROL_PROGRAMS}>
            <TableRestore
                config={buildEntityProgramsListRestoreConfig(entityId)}
            >
                <EntityPrograms entityId={entityId} />
            </TableRestore>
        </EntityViewSideMenu>
    );
}

interface EntityProgramsProps {
    entityId: number;
}

function EntityPrograms({ entityId }: EntityProgramsProps) {
    const { data: programs } = useControlProgramsSuspenseQuery();
    const programsWithEntities = useMemo(() => {
        return mapAsResourceWithoutAction(programs.content).filter((program) =>
            program.controlEntityIds.some((id) => id === entityId)
        );
    }, [programs, entityId]);

    return (
        <EntityProgramsList
            programsWithEntities={programsWithEntities}
            entityId={entityId}
        />
    );
}
